//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Layout from '@/components/ResponsiveLayout'
import Header from './header'
import { mapMutations, mapState } from 'vuex'
import AccountInvoice from '@/views/billing/AccountInvoice'

export default {
  components: {
    AccountInvoice,
    Layout,
    Header
  },

  data() {
    return {
      form: null // SwoopForm api object
    }
  },

  computed: {
    isPayment() {
      return this.$route.path === '/billing/payment'
    },
    isHistory() {
      return this.$route.path === '/billing/history'
    },
    ...mapState({
      accountInvoiceQuickViewId: state =>
        state.billing.accountInvoiceQuickViewId
    })
  },

  methods: {
    ...mapMutations('billing', ['CLOSE_ACCOUNT_INVOICE_QUICK_VIEW'])
  }
}
